export const getConnectURL = ({ id }) => {
  const baseURL = `https://connect.mundoestudiante.cloud`
  return `${baseURL}/cuestionario/${id}`
}

export const getClassfyAdminURL = ({ id }) => {
  return `https://admin.classfy.online/students/${id}`
}

export const generatePDFURL = documentURL => {
  const encodedURL = encodeURIComponent(documentURL)
  return `https://pdf.mundoestudiante.cloud/?url=${encodedURL}`
}

export const getCondicionesContratacionURL = ({ alumno, academia }) => {
  const document = `https://documents.mundoestudiante.cloud/condiciones-contratacion?academia=${academia}&alumno=${alumno}`
  return generatePDFURL(document)
}

export const getDocumentoRGPD = ({ alumno, academia }) => {
  const document = `https://documents.mundoestudiante.cloud/condiciones-rgpd?academia=${academia}&alumno=${alumno}`
  return generatePDFURL(document)
}

export const getBienvenidaAlumno = ({ alumno, academia }) => {
  const document = `https://documents.mundoestudiante.cloud/bienvenida-alumno?academia=${academia}&alumno=${alumno}`
  return generatePDFURL(document)
}

export const getPresupuesto = ({
  academia,
  mes,
  alumno,
  matricula,
  tarifa_nombre,
  tarifa_precio,
  tarifa_condiciones,
  tarifa_base_precio
}) => {
  const baseURL = `https://documents.mundoestudiante.cloud/presupuesto`
  const params = new URLSearchParams({
    academia,
    mes,
    alumno,
    matricula,
    tarifa_nombre,
    tarifa_precio,
    tarifa_condiciones: tarifa_condiciones.join(';'),
    tarifa_base_precio
  })
  return generatePDFURL(`${baseURL}?${params}`)
}

export const getCertificadoAlumno = ({
  academia,
  fecha,
  alumno,
  formacion,
  fecha_inicio,
  fecha_fin,
  curso_academico,
  pagador,
  identificacion_pagador,
  desembolso
}) => {
  const baseURL = `https://documents.mundoestudiante.cloud/certificado-alumno`
  const params = new URLSearchParams({
    academia,
    fecha,
    alumno,
    formacion,
    fecha_inicio,
    fecha_fin,
    curso_academico,
    pagador,
    identificacion_pagador,
    desembolso
  })
  return generatePDFURL(`${baseURL}?${params}`)
}

export const getJustificantePago = ({
  academia,
  nombre,
  alumno,
  referencia,
  mes,
  fecha_emision,
  importe
}) => {
  const baseURL = `https://documents.mundoestudiante.cloud/justificante-pago`
  const params = new URLSearchParams({
    academia,
    nombre,
    alumno,
    referencia,
    mes,
    fecha_emision,
    importe
  })
  return generatePDFURL(`${baseURL}?${params}`)
}

export const getFactura = ({
  academia,
  numero_factura,
  cliente,
  nif,
  referencia,
  fecha_emision,
  concepto,
  importe
}) => {
  const baseURL = `https://documents.mundoestudiante.cloud/factura`
  const params = new URLSearchParams({
    academia,
    numero_factura,
    cliente,
    nif,
    referencia,
    fecha_emision,
    concepto,
    importe
  })
  return generatePDFURL(`${baseURL}?${params}`)
}
